/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcedureAirwaysInner } from './procedureAirwaysInner';
import { ProcedureDetails } from './procedureDetails';
import { ProcedureDisciplineFields } from './procedureDisciplineFields';
import { ProcedureGetResources200ResponseInnerApproachesInner } from './procedureGetResources200ResponseInnerApproachesInner';


/**
 * 
 */
export interface Procedure { 
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    amount?: number;
    /**
     * 
     */
    type: string;
    /**
     * 
     */
    createTS?: string;
    /**
     * 
     */
    userlocationId: string;
    /**
     * 
     */
    locationId?: string;
    /**
     * 
     */
    location?: string;
    /**
     * 
     */
    supervisorId?: number;
    /**
     * 
     */
    supervisorName?: number;
    /**
     * 
     */
    evaluationType?: Procedure.EvaluationTypeEnum;
    /**
     * 
     */
    evaluationStatus?: Procedure.EvaluationStatusEnum;
    /**
     * 
     */
    evaluationTS?: string;
    /**
     * 
     */
    evaluationRequestedTS?: string;
    /**
     * 
     */
    evaluationLevel?: string;
    /**
     * 
     */
    evaluationLevels?: Array<string>;
    /**
     * 
     */
    date: string;
    details?: ProcedureDetails;
    disciplineFields?: ProcedureDisciplineFields;
    /**
     * 
     */
    listId: number;
    /**
     * 
     */
    list: string;
    /**
     * 
     */
    categoryId: number;
    /**
     * 
     */
    age?: string;
    /**
     * 
     */
    ageMonths?: string;
    /**
     * 
     */
    gender?: Procedure.GenderEnum;
    /**
     * 
     */
    birthdate?: string;
    /**
     * 
     */
    otherSpeciality?: string;
    /**
     * 
     */
    category: string;
    /**
     * 
     */
    nameId: number;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    refkey: string;
    /**
     * 
     */
    onco: string;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    level?: string;
    /**
     * 
     */
    approachId: number;
    /**
     * 
     */
    internshipYear?: number;
    /**
     * 
     */
    approach: string;
    /**
     * 
     */
    ageCat?: string;
    /**
     * 
     */
    ageCatId?: number;
    /**
     * 
     */
    disciplineId?: number;
    /**
     * 
     */
    discipline?: string;
    /**
     * 
     */
    method?: string;
    /**
     * 
     */
    methodId?: number;
    /**
     * 
     */
    localisation?: string;
    /**
     * 
     */
    localisationId?: number;
    /**
     * 
     */
    techniques?: Array<ProcedureGetResources200ResponseInnerApproachesInner>;
    /**
     * 
     */
    asaClassification?: number;
    /**
     * 
     */
    airways?: Array<ProcedureAirwaysInner>;
    /**
     * 
     */
    airwaysOther?: Array<ProcedureAirwaysInner>;
    /**
     * 
     */
    neuraxial?: Array<ProcedureAirwaysInner>;
    /**
     * 
     */
    locoregional?: Array<ProcedureAirwaysInner>;
    /**
     * 
     */
    lines?: Array<ProcedureAirwaysInner>;
    /**
     * 
     */
    monitoring?: Array<ProcedureGetResources200ResponseInnerApproachesInner>;
    /**
     * 
     */
    complications?: Array<ProcedureGetResources200ResponseInnerApproachesInner>;
    /**
     * 
     */
    hasAssessment?: boolean;
    /**
     * 
     */
    hasValidatedAssessment?: boolean;
    /**
     * 
     */
    assessmentEvaluatedTS?: string;
    /**
     * 
     */
    assessmentDate?: string;
    /**
     * 
     */
    assessmentType?: string;
    /**
     * 
     */
    assessmentStatus?: string;
    /**
     * 
     */
    assessmentId?: number;
    /**
     * 
     */
    assessmentSupervisorName?: string;
    /**
     * 
     */
    assessmentSupervisorId?: number;
}
export namespace Procedure {
    export type EvaluationTypeEnum = 'autonomy-level' | 'procedure-evaluation';
    export const EvaluationTypeEnum = {
        AutonomyLevel: 'autonomy-level' as EvaluationTypeEnum,
        ProcedureEvaluation: 'procedure-evaluation' as EvaluationTypeEnum
    };
    export type EvaluationStatusEnum = 'requested' | 'validated';
    export const EvaluationStatusEnum = {
        Requested: 'requested' as EvaluationStatusEnum,
        Validated: 'validated' as EvaluationStatusEnum
    };
    export type GenderEnum = 'm' | 'v';
    export const GenderEnum = {
        M: 'm' as GenderEnum,
        V: 'v' as GenderEnum
    };
}


